import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(() => ({
  stepperContent: {
    maxWidth: 500,
  },
}));
